import { JWPlayerVideos } from "@advice/apps/initJWPlayerVideos";
import { initHeader } from "@advice/apps/initHeader";
import { initEmailCapture } from "@advice/apps/initEmailCapture";
import { initJobsSidebar } from "@advice/apps/initJobsSidebar";
import { initLazyImages } from "@advice/apps/initLazyImages";
import { initOskarTriggers } from "@advice/apps/initOskarTriggers";
import { IInitialState } from "@server/util/pageWrapper";
import { ExperimentAB, IExperimentAB } from "@util/experiment";
import { initGrowform } from "./apps/initGrowform";
import { initExperiment } from "./apps/initExperiment";

export interface AdviceWindow extends Window {
    __MUSE__: {
        initialState: IInitialState;
    };
    dataLayer: IMetadataObj[];
    experiment: IExperimentAB;
    ga: UniversalAnalytics.ga;
}

declare const window: AdviceWindow;

document.addEventListener("DOMContentLoaded", async () => {
    const initialState = window.__MUSE__.initialState;
    initLazyImages();
    window.experiment = new ExperimentAB(initialState?.config?.experiments);
    const excludedPages = [
        "test-listicle-5-21-2020", // This is to test on staging and local
        "interview-questions-and-answers" // This is the live article
    ];
    const excludeExperiment = excludedPages.includes(initialState.slug);

    if (!excludeExperiment) {
        await initExperiment();
    }
    await initHeader(initialState);
    await initJobsSidebar();
    if (window.experiment.isAssignedExperiment("JOB_QUIZ_FORM") &&
        !window.dataLayer[0].is_sponsored &&
        !excludeExperiment &&
        window.experiment.currentVariant.name !== "control"
    ) {
        await initGrowform();
    }
    await initOskarTriggers();
    await initEmailCapture(initialState);
    const jwPlayerID = ((initialState || {}).config || {}).jwPlayerID;
    if (jwPlayerID) {
        try {
            JWPlayerVideos.initJWPlayerVideos(jwPlayerID, initialState?.config);
        } catch (error) {
            console.error("Could not initialize JWPlayer Videos: ", error);
        }
    }
});
